import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import Tab from "react-bootstrap/Tab";

function Main({ activeIndex, setActiveIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <ListGroup>
                <ListGroup.Item
                    onClick={() => setActiveIndex(0)}
                    className={`p-3 ${activeIndex === 0 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Overview
                </ListGroup.Item>
                <ListGroup.Item
                    onClick={() => setActiveIndex(1)}
                    className={`p-3 ${activeIndex === 1 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Doctors
                </ListGroup.Item>

                <ListGroup.Item
                    onClick={() => setActiveIndex(2)}
                    className={`p-3 ${activeIndex === 2 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Staff Nurse
                </ListGroup.Item>

                <ListGroup.Item
                    onClick={() => setActiveIndex(3)}
                    className={`p-3 ${activeIndex === 3 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Facilities
                </ListGroup.Item>

                <ListGroup.Item
                    onClick={() => setActiveIndex(4)}
                    className={`p-3 ${activeIndex === 4 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Referral Hospitals
                </ListGroup.Item>

                <ListGroup.Item
                    onClick={() => setActiveIndex(5)}
                    className={`p-3 ${activeIndex === 5 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Emergency Contacts
                </ListGroup.Item>

                <ListGroup.Item
                    onClick={() => setActiveIndex(6)}
                    className={`p-3 ${activeIndex === 6 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Gallery
                </ListGroup.Item>
            </ListGroup>
        </Tab.Container>
    );
}
export default Main;
